import { render, staticRenderFns } from "./TeachingQuestionModal.vue?vue&type=template&id=d8860f1c"
import script from "./TeachingQuestionModal.vue?vue&type=script&lang=js"
export * from "./TeachingQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports